module.exports = __webpack_public_path__ + "static/media/not-equal.b68d2c6a.svg";